import { useState } from "react";
import { FileText, X } from "lucide-react";
import PitchDeckRequestModal from "@/components/PitchDeckRequestModal";

/**
 * Floating "Send me the pitch deck" pill for demo-tenant users — the visitor
 * is already playing with the product, so this is where we convert them into
 * a named lead. Dismissible per session.
 */
export default function PitchDeckFab() {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("ssp_deck_fab_hidden") === "1");

  if (hidden) return null;

  const dismiss = () => {
    sessionStorage.setItem("ssp_deck_fab_hidden", "1");
    setHidden(true);
  };

  return (
    <>
      <div className="fixed bottom-5 right-5 z-40 flex items-center shadow-2xl rounded-full bg-primary text-primary-foreground">
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="flex items-center gap-2 pl-4 pr-2 py-2.5 text-sm font-bold rounded-l-full hover:brightness-110 transition-[filter]"
          data-testid="demo-pitch-deck-fab"
        >
          <FileText className="w-4 h-4" /> Send me the pitch deck
        </button>
        <button
          type="button"
          onClick={dismiss}
          className="p-2 pr-3 rounded-r-full opacity-70 hover:opacity-100"
          data-testid="demo-pitch-deck-fab-dismiss"
          aria-label="Dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
      <PitchDeckRequestModal open={open} onClose={() => setOpen(false)} source="demo" />
    </>
  );
}
